<template>
  <ValidationProvider
    v-slot="{ errors }"
    v-bind="validationAttr"
  >
    <BFormGroup
      v-bind="formGroupAttr"
      :label-for="inputID"
    >
      <BFormSelect
        :id="inputID"
        v-model="proxyValue"
        v-bind="$attrs"
        :state="errors.length > 0 ? false : null"
      >
        <template #first>
          <BFormSelectOption
            value=""
            disabled
          >
            {{ $attrs?.placeholder || '-- select here --' }}
          </BFormSelectOption>
        </template>
      </BFormSelect>
      <div
        v-if="(errors.length > 0)"
        class="invalid-feedback"
        v-text="errors[0]"
      />
    </BFormGroup>
  </ValidationProvider>
</template>
<script>
import MxMisc from '@/mixins/misc'

export default {
  name: 'WVTextarea',

  mixins: [
    MxMisc
  ],

  inheritAttrs: false,

  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    validationAttr: {
      type: Object,
      default: () => ({})
    },
    formGroupAttr: {
      type: Object,
      default: () => ({})
    }
  },

  emits: ['input'],

  data () {
    return {
      proxyValue: '',
      inputID: `WVID_${String(this.generateId(10)).toUpperCase()}_${this._uid}`
    }
  },

  watch: {
    value (val) {
      this.proxyValue = val
    },
    proxyValue (val) {
      this.$emit('input', val)
    }
  },

  mounted () {
    this.proxyValue = this.value
  }
}
</script>
